import styled, { css } from 'styled-components';
import { type SxProps } from '@mui/material';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _dark = clientThemePalette[CLIENT_THEME].dark;

interface NotificationProps {
  isRead: boolean;
}

export const Notification = styled.span<NotificationProps>`
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  ${({ isRead }) =>
    !isRead &&
    css`
      font-weight: 700;
      text-decoration: underline;
    `}
`;

export const ListItemText = styled.span`
  color: #000000;
  padding: 0px 0px 0px 10px;
`;

export const defaultTabStyle: SxProps = {
  padding: '0px',
  color: '#FFFFFF',
  backgroundColor: _dark.primary,
  minHeight: '30px',
  minWidth: '30px',
  '&:hover': {
    backgroundColor: _dark.primaryDark,
  },
};

export const disabledTabStyle: SxProps = {
  padding: '0px',
  color: '#7485A2',
  border: '1px solid #77859F',
  borderRadius: '5px',
  backgroundColor: 'transparent',
  minHeight: '30px',
  minWidth: '30px',
};
